import React from 'react';
import "./credits.css"
import { Helmet } from 'react-helmet-async';

const Credits = () => {
    return (
        <>
            <Helmet>
                <title>Credits sito web | A.G Pulizie</title>
                <meta
                    name="description"
                    content="Credits del sito A.G Pulizie. Website e design realizzati da Valentina Vittoria."
                />
                <link rel="canonical" href="https://agpulizie.com/credits" />

                <meta property="og:title" content="Credits sito web | A.G Pulizie" />
                <meta
                    property="og:description"
                    content="Website e design realizzati da Valentina Vittoria."
                />
                <meta property="og:url" content="https://agpulizie.com/credits" />
                <meta property="og:type" content="website" />

                {/* opzionale: usa questo se NON vuoi indicizzare la pagina credits */}
                {/* <meta name="robots" content="noindex, follow" /> */}
            </Helmet>

            <div id='credits'>
                <h2 className='title title-credits'>Site Credits</h2>
                <div className='container-text-credits'><span className='bold-credits'>Website & Design :</span><a className='credits-website' href='https://valentinavittoria.com/' rel="noreferrer" target='_blank'> Valentina Vittoria</a></div>
                <div className='container-text-credits'>
                    <div className='bold-credits pictures'>Pictures :</div>
                    <ul>
                        <li>+ Green Plant on White Wooden Table by Daria Shevtsova</li>
                        <li>+ Modern studio apartment interior by Max Rahubovskiy</li>
                        <li>+ Interior of Clothing Store by Rachel Claire </li>
                    </ul>
                </div>
                <div className='back-home-text-container'>
                    <a href='/' className=''>Torna Indietro</a>
                </div>
            </div>
        </>
    );
}

export default Credits;
